import { Check } from "lucide-react";
import { cn } from "~/lib/utils";

export const Steps = ({
  currentStep,
  numberOfSteps,
  variant = "simple",
  className,
}: {
  currentStep: number;
  numberOfSteps: number;
  variant?: "simple" | "bubbles";
  className?: string;
}) => {
  if (variant === "simple") {
    return (
      <div>
        <div className="flex">
          {Array.from({ length: numberOfSteps }, (_, i) => i + 1).map(
            (step) => (
              <div
                key={step}
                className={`${
                  currentStep >= step ? "bg-black" : "bg-lemon-dark"
                } w-full h-1 rounded-full`}
              />
            ),
          )}
        </div>
        <p className="text-base mt-1">
          Step {currentStep} / {numberOfSteps}
        </p>
      </div>
    );
  }

  return (
    <nav aria-label="Progress" className={cn("w-full", className)}>
      <ol role="list" className="flex items-center justify-between w-full">
        {Array.from({ length: numberOfSteps }, (_, i) => i + 1).map((step) => {
          return (
            <li
              className={cn("relative", step !== numberOfSteps ? "w-full" : "")}
              key={`steps-${step}`}
            >
              <div
                aria-hidden="true"
                className="absolute inset-0 flex items-center"
              >
                <div className="h-0.5 w-full bg-black"></div>
              </div>
              <a
                href="#"
                className={cn(
                  "relative flex size-8 items-center justify-center rounded-full border-2 border-black",
                  step < currentStep ? "bg-primary" : "bg-white",
                )}
              >
                {step < currentStep ? (
                  <>
                    <Check className="size-5 text-black" />
                    <span className="sr-only">Step {step}</span>
                  </>
                ) : (
                  <span className="size-5 text-black text-center font-semibold -translate-y-px">
                    {step}
                  </span>
                )}
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
